import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getBrandI18nVars } from '../config/brand.config';
import en from './en.json';
import ar from './ar.json';
import zh from './zh.json';
import ko from './ko.json';

const storedLang = localStorage.getItem('language');
const initialLang = storedLang && ['en', 'ar', 'zh', 'ko'].includes(storedLang) ? storedLang : 'en';
if (storedLang === 'fa') {
  localStorage.setItem('language', 'en');
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
    zh: { translation: zh },
    ko: { translation: ko },
  },
  lng: initialLang,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
    defaultVariables: getBrandI18nVars(),
  },
});

export default i18n;





